import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import {
  extractTabKeys,
  useTabQuery,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import * as css from './emsp-bo-rfid-badge-order-details.module.scss';
import { InformationTabComponent } from './tabs/information-tab/information-tab.component';

enum TabsEnum {
  INFORMATION = 'information-tab',
}

export const EmspBoRfidBadgeOrderDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  const tabs = useMemo(
    () =>
      [
        {
          title: t('$.emsp-bo-rfid-badge-order-details.information.title'),
          icon: 'credit-card-refresh',
          key: TabsEnum.INFORMATION,
        },
      ] as const,
    [t],
  );

  const { tab, setTab } = useTabQuery(
    TabsEnum.INFORMATION,
    extractTabKeys(tabs),
  );

  const renderTab = (): React.JSX.Element | null => {
    switch (tab) {
      case TabsEnum.INFORMATION:
        return <InformationTabComponent />;
      default:
        return null;
    }
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack
      className={css.emspBoRfidBadgeOrderDetails}
      direction="column"
      gap={GapEnum.XL}>
      {tabs.length > 1 && (
        <Tabs currentTab={tab} elements={tabs} onTabClick={setTab} />
      )}
      {renderTab()}
    </Stack>
  );
};
